import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { Category } from 'src/app/types/types';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})

// Categorias : 
/**
 * 0-6 meses,
 * 6m a 3 años .
 * 3 a 9 años
 * lenceria y accesorios (Medias,baberos,chupetes,toallitas,cambiadores)
 */
export class CategoriesComponent implements OnInit {

  categories : Category[] = []

  constructor( 
    private router : Router,
    private productService : ProductService
    ) { 
      this.categories = productService.getCategories();
    }

  ngOnInit(): void {
  }

  pushToCategory(category : Category) {
    this.router.navigate(["products",category.name])
  }

}
